import {AUTO_DELIVERY_FREQUENCY_TYPES, AutoDeliveryFrequency} from '@/consts/icc/iccAutoDeliveryStatusTypes';
import {AutoDeliveryRescheduleSelectFrequencyContent} from '@/types/content/autoDelivery/autoDeliveryRescheduleDeliveryContentModel';

type FrequencyButtonKey = 'dailyButton' | 'weeklyButton' | 'biweeklyButton' | 'monthlyButton' | 'bimonthlyButton';

export type FrequencyOption = {
    key: AutoDeliveryFrequency;
    label: string;
    alt?: string;
};

const ALL_FREQUENCIES = Object.values(AUTO_DELIVERY_FREQUENCY_TYPES) as AutoDeliveryFrequency[];

const BUTTON_KEY_BY_FREQUENCY: Record<AutoDeliveryFrequency, FrequencyButtonKey> = {
    [AUTO_DELIVERY_FREQUENCY_TYPES.DAILY]: 'dailyButton',
    [AUTO_DELIVERY_FREQUENCY_TYPES.WEEKLY]: 'weeklyButton',
    [AUTO_DELIVERY_FREQUENCY_TYPES.BIWEEKLY]: 'biweeklyButton',
    [AUTO_DELIVERY_FREQUENCY_TYPES.MONTHLY]: 'monthlyButton',
    [AUTO_DELIVERY_FREQUENCY_TYPES.BIMONTHLY]: 'bimonthlyButton',
};

const getFrequencyButton = (
    selectFrequencyContent: AutoDeliveryRescheduleSelectFrequencyContent | undefined,
    frequency: AutoDeliveryFrequency
) => {
    const buttonKey = BUTTON_KEY_BY_FREQUENCY[frequency];

    return selectFrequencyContent?.[buttonKey];
};

export const getFrequencyOptions = (
    selectFrequencyContent: AutoDeliveryRescheduleSelectFrequencyContent | undefined
): FrequencyOption[] =>
    ALL_FREQUENCIES.map((frequency) => {
        const frequencyButton = getFrequencyButton(selectFrequencyContent, frequency);

        return {
            key: frequency,
            label: frequencyButton?.text,
            alt: frequencyButton?.alt,
        };
    }).filter(({label}) => Boolean(label)) as FrequencyOption[];

export const getFrequencyLabel = (
    selectFrequencyContent: AutoDeliveryRescheduleSelectFrequencyContent | undefined,
    frequency: AutoDeliveryFrequency
) => getFrequencyButton(selectFrequencyContent, frequency)?.text ?? frequency;
